const pageValue = value => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? String(page) : '1';
};
const sortValue = value =>
  typeof value === 'string' &&
  /^-?(name|domain|created_at|last_activity_at|contacts_count)$/.test(value)
    ? value
    : 'name';

export const companyListContext = query => ({
  listPage: pageValue(query.page),
  listSearch: typeof query.search === 'string' ? query.search : '',
  listSort: sortValue(query.sort),
});

export const companyListReturnQuery = query => ({
  page: pageValue(query.listPage),
  ...(typeof query.listSearch === 'string' && query.listSearch
    ? { search: query.listSearch }
    : {}),
  sort: sortValue(query.listSort),
});

export const companyDetailTab = value =>
  ['history', 'notes', 'contacts', 'attributes'].includes(value)
    ? value
    : 'history';
